import { Theme, css } from '@emotion/react';

const resyNetworkBannerCssDefs = {
  banner: ({ colors, spacing }: Theme) => css`
    align-items: center;
    background: ${colors.bgContrast};
    display: flex;
    gap: ${spacing(1.5)}px;
    justify-content: center;
    padding: ${spacing(1.5)}px ${spacing(2.5)}px;
    width: 100%;
  `,
  logo: css`
    flex-shrink: 0;
    height: 32px;
    width: auto;
  `,
  link: ({ colors, interactiveStates }: Theme) => css`
    color: ${colors.fgContrast};
    ${interactiveStates.hover(css`
      color: ${colors.fgContrast};
    `)}
    ${interactiveStates.active(css`
      color: ${colors.fgContrast};
    `)}
    &.MuiLink-root:visited {
      color: ${colors.fgContrast};
    }
  `,
};

export default resyNetworkBannerCssDefs;
